export const addShouldNotForwardProps = <T>(
  ...shouldNotForwardProps: Array<T | string | number | symbol>
) => (prop: PropertyKey) => !shouldNotForwardProps.includes(prop);
